export enum TrackingVariantICE {
    ADDTOCART = 'addToCart',
}